import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Search, FilterX } from 'lucide-react';

interface MainSearchBarProps {
  searchQuery: string;
  setSearchQuery: (query: string) => void;
  selectedAdventure: any | null;
}

export const MainSearchBar = ({
  searchQuery,
  setSearchQuery,
  selectedAdventure
}: MainSearchBarProps) => {
  const { t } = useTranslation('public', { keyPrefix: 'customAdventures' });

  if (selectedAdventure) return null;

  return (
    <div className="mb-8">
      <div className="relative">
        <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 h-5 w-5 z-10" />
        <Input
          placeholder={t('search.placeholder')}
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          className="pl-10 py-6 text-base bg-white shadow-sm rounded-full border-gray-300 focus:ring-primary focus:border-primary"
        />
        {searchQuery && (
          <Button
            variant="ghost"
            className="absolute right-2 top-1/2 transform -translate-y-1/2 p-0 h-8 w-8 rounded-full text-gray-500 hover:bg-gray-100"
            onClick={(e) => { e.preventDefault(); setSearchQuery(''); }}
            size="icon"
            aria-label={t('search.clearSearch')}
            type="button"
          >
            <FilterX className="h-5 w-5" />
          </Button>
        )}
      </div>
    </div>
  );
};
